export default __webpack_public_path__ + "02cb6dd4466e210fe4a6642a75f13bde.png";